import React from "react";

function Overlay(props) {
  return (
    <div className="w-full h-screen bg-overlay z-20 absolute left-0 top-0 flex overflow-y-scroll pt-16">
      {props.children}
      {/* <h1>dfjiskhfoaskl</h1>
      <p className="w-20">sdasjhkkkkkkkkkafkjdfamkljfolajhjkfhsnklfhvnab,jvhamjbfvank,hnvakbvbaj</p> */}
    </div>
  );
}

export default Overlay;
